import { IconName } from '@optimus-web/icons';
import { Stack } from '../Stack';
import { GhostIconButton, PageText } from './styles';
import { PaginationProps } from './types';

export const MobilePagination = ({ selected, size, onClick, ...other }: PaginationProps) => {
    if (size < 1) {
        return null;
    }

    const hasPrevious = selected > 0;
    const hasNext = selected < size - 1;

    const handlePrevPageClick = () => {
        onClick(selected - 1);
    };

    const handleNextPageClick = () => {
        onClick(selected + 1);
    };

    return (
        <Stack itemAlignment="center" spacing="100" {...other}>
            <GhostIconButton
                variant="ghost"
                icon={IconName.ChevronLeft}
                onClick={handlePrevPageClick}
                disabled={!hasPrevious}
                size="small"
                accessibleText="Previous page"
                type="button"
            />
            <PageText>{`${selected + 1} / ${size}`}</PageText>
            <GhostIconButton
                variant="ghost"
                icon={IconName.ChevronRight}
                onClick={handleNextPageClick}
                disabled={!hasNext}
                size="small"
                accessibleText="Next page"
                type="button"
            />
        </Stack>
    );
};
